import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-annotation-modal',
    templateUrl: './annotation-modal.component.html',
    styleUrls: ['./annotation.component.scss'],
    standalone: false
})
export class AnnotationModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter();

  _description = '';
  get description(): any {
    return this._description;
  }
  @Input() set description(value: any) {
    this._description = value;
  }

  @Output() descriptionChange = new EventEmitter();

  save() {
    this.descriptionChange.emit(this.description);
    this.showModal = false;
    this.showModalChange.emit(false);
  }

  cancel() {
    this.showModal = false;
    this.showModalChange.emit(false);
  }
}
